import { CoreDrawer } from "@/components/common/CoreDrawer";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { useConversationById } from "@/hooks/conversation/useConversations";
import { ConversationDetailPageContent } from "@/pages/UserHub/ConversationDetailPage";
import type { ConversationDetailsProps } from "@/types/conversation/conversation";

/**
 * Side-sheet entry point for the same analysis surface as the full-page route.
 */
export function ConversationDetails({ isOpen, onClose, conversation, conversationId }: ConversationDetailsProps) {
  const source = useConversationById(isOpen && !conversation ? conversationId ?? null : null);
  const currentConversation = conversation ?? source.data;
  return (
    <CoreDrawer
      isOpen={isOpen}
      onClose={onClose}
      title={`Analysis - ${currentConversation?.agent?.name || "Conversation"}`}
      className="sm:!max-w-[95vw] lg:!max-w-[1500px]"
    >
      {currentConversation ? (
        <ConversationDetailPageContent key={currentConversation.id} conversation={currentConversation} inDrawer />
      ) : source.isError ? (
        <div role="alert" className="space-y-3 py-6">
          <p className="text-sm text-red-600">
            We couldn't load this conversation. Please try again.
          </p>
          <Button variant="outline" onClick={() => source.refetch()} disabled={source.isFetching}>
            {source.isFetching ? "Retrying…" : "Try again"}
          </Button>
        </div>
      ) : (
        <div role="status" className="flex items-center gap-3 py-6">
          <Loader2 className="h-5 w-5 animate-spin text-genie-primary" />
          <span className="text-sm text-gray-600">Loading conversation…</span>
        </div>
      )}
    </CoreDrawer>
  );
}
